import KnownFor from './KnownFor';

export default KnownFor;